// extracted by mini-css-extract-plugin
export default {"game_field":"SpaceGame_game_field__zkeVD","player":"SpaceGame_player__50BWy"};